import { ModalDesafioMasInformacion } from './ModalDesafioMasInformacion';

import { Button } from '@/components';
import { MainBox } from '@/components/GenericsTournaments';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { EnumContextGDT } from '@/types/team';

export const ChallengeNoData = () => {
  const { isMobile } = useIsDesktop();
  if (isMobile) {
    return null;
  }
  const { ModalInfo, setIsModalDesafioOpen } = ModalDesafioMasInformacion();

  return (
    <MainBox className="!mt-6" context={EnumContextGDT.Challenge}>
      <p className="text-gdt-gray-2">
        No tenés rivales para la próxima fecha.
        <br />
        <strong>
          Buscá a un amigo o desafiá a uno de <br /> los DTs recomendados.
        </strong>
      </p>
      <Button
        className="mt-8 mx-auto font-bold cursor-pointer"
        type="button"
        variant="text"
        onClick={() => setIsModalDesafioOpen(true)}
      >
        Más información
      </Button>

      <ModalInfo />
    </MainBox>
  );
};
